import { useToast } from 'vue-toastification'

export default class Toaster  {

    handleResponse(res) {
        if (res.alert == 'info') {
            this.showSuccess(res.msg)
        }
        else {
            this.showError(res.msg);
        }
    }

    showSuccess(payload) {
        const toast = useToast();
        toast.success(payload, { timeout: 7000 });
    }

    showError(payload) {
        const toast = useToast();
        toast.error(payload, { timeout: 10000 });
    }

    showWarning(payload) {
        const toast = useToast();
        toast.warning(payload, { timeout: 7000 });
    }

    showInfo(payload) {
        const toast = useToast();
        toast.info(payload, { timeout: 7000 });
    }
}